
export enum StatusRequest {
    SUBMITTED = "pt.edp.edponline.support.help.submetido",
    CREATED = "pt.edp.edponline.support.help.E0001",
    ASSIGN = "pt.edp.edponline.support.help.E0002",
    PENDING = "pt.edp.edponline.support.help.E0004",
    RESOLVED = "pt.edp.edponline.support.help.E0007"
}
